import { Box, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";
import { isPortrait } from "@/utilities/useOrientation";

import Header from "./Header";

const TowerSelection = ({ developmentData, setViewSelected, setStep }) => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const [zoomed, setZoomed] = useState(false);
    const [translatePosX, setTranslatePosX] = useState("-850px");
    const [previousX, setPreviousX] = useState(0);
    const [isTouching, setIsTouching] = useState(false);
    const [svgContainerWidth, setSvgContainerWidth] = useState(0);
    const [svgWidth, setSvgWidth] = useState(0);

    const orientation = isPortrait() ? "portrait" : "landscape";

    useEffect(() => {
        if (isGreaterThanMd && orientation === "portrait") {
            setTranslatePosX("-1650px");
        } else {
            setTranslatePosX("-850px");
        }
    }, [orientation, isGreaterThanMd]);

    const loadSvg = () => {
        const svg = document.getElementById("svg");
        if (svg) {
            // ==== VALIDATE TO IDENTIFY TYPE OF TAG ON IMAGE SVG ====
            let elementTagName = null;
            const rect = Array.from(svg.getElementsByTagName("rect"));
            const path = Array.from(svg.getElementsByTagName("path"));
            elementTagName = rect.concat(path);
            for (let i = 0; i < elementTagName.length; i++) {
                const element = elementTagName[i];
                if (element.id) {
                    const regex_uuid =
                        /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
                    const is_uuid = regex_uuid.test(element.id);
                    if (is_uuid) {
                        element.style.cursor = "pointer";
                        //Add hover effect
                        element.addEventListener("mouseover", () => {
                            element.setAttribute("opacity", 1);
                            element.setAttribute("fill-opacity", 1);
                        });
                        element.addEventListener("mouseout", () => {
                            element.setAttribute("opacity", 0.1);
                            element.setAttribute("fill-opacity", 0.1);
                        });
                    }
                }
            }
            const svgContainer = document.getElementById("svg-container");

            if (svgContainer && svg) {
                setSvgContainerWidth(svgContainer.clientWidth); // Usamos clientWidth en lugar de offsetWidth
                setSvgWidth(svg.clientWidth); // Ancho del SVG
            }
        }
    };

    const handleSelect = (e) => {
        const regex_uuid = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
        const is_uuid = regex_uuid.test(e.target.id);
        if (!is_uuid) return;
        setZoomed(true);
        setTimeout(() => {
            setViewSelected(e.target.id);
            setStep(2);
            setZoomed(false);
        }, 500);
    };

    const handleDragStart = (e) => {
        var touch = e.touches[0] || e.changedTouches[0];
        setPreviousX(touch.pageX); // Guardamos la posición inicial
        setIsTouching(true);
    };

    const handleDrag = (e) => {
        if (!isTouching) return;

        e.preventDefault();
        var touch = e.touches[0] || e.changedTouches[0]; // Detectar el primer toque
        const mouse_position = { x: touch.pageX, y: touch.pageY }; // Obtener la posición X y Y del toque

        const minTranslateX = -(svgWidth - svgContainerWidth); // Limite izquierdo
        const maxTranslateX = 0; // Limite derecho

        const deltaX = mouse_position.x - previousX;

        let newTranslateX = parseFloat(translatePosX.replace("px", "")) + deltaX;

        newTranslateX = Math.min(Math.max(newTranslateX, minTranslateX), maxTranslateX);

        setTranslatePosX(`${newTranslateX}px`);
        setPreviousX(mouse_position.x);
    };

    const handleDragEnd = () => {
        setIsTouching(false); // Finalizamos el toque
    };

    return (
        <Box
            w="100vw"
            height="100vh"
            onTouchMove={(e) => handleDrag(e)}
            onTouchStart={(e) => handleDragStart(e)}
            onTouchEnd={(e) => handleDragEnd(e)}
        >
            <Header developmentData={developmentData} step={1} />
            <Box
                id="svg-container"
                position="absolute"
                width="100vw"
                height="100vh"
                bgImage={wrapBgImage(developmentData?.branding_props?.render_master)}
                bgRepeat="no-repeat"
                bgPosition="center"
                bgSize="cover"
                top={0}
            >
                <SVG
                    preserveAspectRatio="xMidYMid meet"
                    style={{
                        width: isGreaterThanMd && orientation === "landscape" ? "100%" : "auto",
                        height: "100%",
                        objectFit: "cover",
                        transform: zoomed
                            ? "scale(1.7)"
                            : isGreaterThanMd && orientation === "landscape"
                              ? "scale(1)"
                              : `translateX(${translatePosX}) scale(1)`,
                        transition: "transform 1s ease-in-out",
                        filter: zoomed ? "blur(5px)" : "blur(0px)",
                    }}
                    id="svg"
                    src={developmentData?.branding_props?.render_master}
                    cursor="pointer"
                    height="100%"
                    onClick={(e) => handleSelect(e)}
                    onLoad={loadSvg}
                />
                {(!isGreaterThanMd || (isGreaterThanMd && orientation === "portrait")) && (
                    <Box
                        position="absolute"
                        width="100%"
                        height="15%"
                        bottom={0}
                        justifyItems="center"
                        placeItems="center"
                        cursor="move"
                    >
                        <Text
                            color="white"
                            fontSize={isGreaterThanMd && orientation == "portrait" ? "2xl" : "sm"}
                            textAlign="center"
                        >
                            Desliza la pantalla
                        </Text>
                        <Image
                            src="https://media.grupoguia.mx/vision/icon/slide.svg"
                            width="90%"
                            height="auto"
                            maxH="3vh"
                            maxW="35%"
                            my={4}
                        />
                        <Text
                            color="white"
                            fontSize={isGreaterThanMd && orientation == "portrait" ? "3xl" : "md"}
                            textAlign="center"
                        >
                            Selecciona una torre
                        </Text>
                    </Box>
                )}
                {isGreaterThanMd &&
                    developmentData?.branding_props?.selection_props?.selection_text &&
                    orientation === "landscape" && (
                        <Box
                            position="absolute"
                            width="100%"
                            height="7%"
                            bottom={0}
                            justifyItems="center"
                            placeItems="center"
                        >
                            <Text color="white" fontSize="1.8vh" textAlign="center">
                                {developmentData?.branding_props?.selection_props?.selection_text}
                            </Text>
                        </Box>
                    )}
            </Box>
        </Box>
    );
};

export default TowerSelection;
